import { useState } from 'react'
import AlarmIcon from '../assets/icons/alarm1.svg'
import { useWallet } from '../context/WalletContext'

export default function ReminderComponent({ profile }) {
    const { updateProfile, isConnected } = useWallet();
    const [saving, setSaving] = useState(false);
    const enabled = Boolean(profile?.reminder_enabled);

    const toggle = async () => {
        if (!isConnected) return;
        setSaving(true);
        try {
            await updateProfile({ reminder_enabled: !enabled });
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex flex-col bg-bg rounded-[16px] px-5 sm:px-[30px] py-5 sm:py-[20px]">
            <p className="text-white text-[22px] sm:text-[28px] font-semibold">Enable reminder</p>
            <div className="text-gray1 text-[16px] sm:text-[18px] font-normal">A reminder is sent by email for the expiration of your will or when your claim is available!</div>
            <button
                className="flex px-[15px] w-full max-w-[220px] py-[10px] justify-center items-center gap-2 mt-4 bg-primary rounded-[56px] min-h-[44px]"
                onClick={toggle}
                disabled={!isConnected || saving}
            >
                <img src={AlarmIcon} alt='ico' />
                <p className="text-black text-[16px] font-semibold">
                    {saving ? 'Saving...' : (enabled ? 'Reminder active' : 'Active reminder')}
                </p>
            </button>
        </div>
    )
}
